import s, { forwardRef as u } from "react";
var m = Object.defineProperty,
  l = Object.getOwnPropertySymbols,
  o = Object.prototype.hasOwnProperty,
  n = Object.prototype.propertyIsEnumerable,
  i = (e, a, r) => a in e ? m(e, a, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : e[a] = r,
  v = (e, a) => {
    for (var r in a || (a = {})) o.call(a, r) && i(e, r, a[r]);
    if (l) for (var r of l(a)) n.call(a, r) && i(e, r, a[r]);
    return e;
  },
  b = (e, a) => {
    var r = {};
    for (var t in e) o.call(e, t) && a.indexOf(t) < 0 && (r[t] = e[t]);
    if (e != null && l) for (var t of l(e)) a.indexOf(t) < 0 && n.call(e, t) && (r[t] = e[t]);
    return r;
  };
const p = u((e, a) => {
  var r = e,
    {
      isOpen: t,
      optionsID: f
    } = r,
    c = b(r, ["isOpen", "optionsID"]);
  return s.createElement("input", v({
    className: "olx-multiselect__input",
    "data-ds-component": "DS-Select-Input",
    ref: a,
    "aria-expanded": t,
    "aria-controls": f,
    role: "combobox",
    "aria-autocomplete": "list",
    type: "text",
    autoComplete: "off"
  }, c));
});
p.displayName = "Filter";
export { p as Filter };